export interface PermissionMenusState {
  userMenus: any[];
  error: string | null;
  loading: boolean;
}

export const initialState: PermissionMenusState = {
  userMenus: [],
  error: null,
  loading: false,
};
